export default {
    "created": "Norma de pontaj a fost creat cu succes",
    "updated": "Norma de pontaj a fost actualizat cu succes",
    "deleted": "Norma de pontaj a fost șters cu succes",
    "restored": "Norma de pontaj a fost restaurat cu succes",
}
